export default function isId(object: unknown): object is string {
  return (
    object !== null &&
    object !== undefined &&
    typeof object === "string" &&
    object !== ""
  );
}
